<template>
  <div class="step-wrapper">
    <div class="step-wrapper-subject"><strong>step 4 | Enter your desired letter spacing</strong></div>
    <div class="step-wrapper-description mt-4">Adjust your desired letter spacing.</div>
    <b-link class="more-info mt-4" v-b-modal.modal-spacing>More Info</b-link>
    <b-form-select v-model="stencileaseTextSpacing" :options="options" class="mt-4" @change.native="changeSpacing" />
    <b-button variant="default" class="mt-4 go-next" v-on:click="goNext">next</b-button>

    <b-modal id="modal-spacing" centered size="lg" title="letter spacing">
      <p class="my-4">Vertically centered modal!</p>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      stencileaseTextSpacing: this.$store.state.product.textSpacing,
      options: [
        { value: '100', text: '100 %' },
        { value: '150', text: '150 %' },
        { value: '200', text: '200 %' },
        { value: '250', text: '250 %' },
        { value: '300', text: '300 %' },
        { value: '350', text: '350 %' },
        { value: '400', text: '400 %' },
        { value: '450', text: '450 %' },
        { value: '500', text: '500 %' }
      ]
    }
  },
  methods: {
    changeSpacing(evt) {
      this.$store.dispatch('product/SET_SPACING', evt.target.value)
    },
    goNext(evt) {
      this.$store.dispatch('product/SET_OLDTAB', 3)

            this.$store.dispatch('product/SET_ACTIVETAB', 3)
      this.$store.dispatch('product/SET_ACTIVETAB', 4)
    }
  }
}
</script>
